<template>
    <div class="popup__steps">
        <div class="popup__step-one">
            <div class="popup__title" @click="openStepPopup(1)">
                <span>1</span>
                <p :class="{ active: currentStepPopup === 1 }">Список услуг</p>
            </div>
            <div class="popup__step-wrap" :class="{ hidden: currentStepPopup !== 1 }">
                <div class="mark-n-model">
                    <div>
                        <p>
                            <span>Марка:</span
                            >{{
                                selectedMark ? selectedMark.mark : "Не выбрано"
                            }}
                        </p>
                        <p>
                            <span>Модель:</span
                            >{{
                                selectedModel
                                    ? selectedModel.model
                                    : "Не выбрано"
                            }}
                        </p>
                    </div>
                    <a
                        href="#"
                        @click.prevent="goToStep(1), $emit('closeCartPopup')"
                    >Изменить</a
                    >
                </div>

                <el-table
                    :data="selectedWorks"
                    style="width: 100%"
                    max-height="230"
                    empty-text="Работы не выбраны"
                >
                    <el-table-column prop="label" label="Вид работ:" width="240">
                    </el-table-column>
                    <el-table-column
                        type="index"
                        label="Цена:"
                        :index="workPriceToFixed"
                        width="80"
                    >
                    </el-table-column>
                    <el-table-column width="20">
                        <template slot-scope="scope">
                            <el-button
                                icon="el-icon-circle-close"
                                class="delete-btn"
                                @click.native.prevent="deleteRow(scope)"
                                type="text"
                                size="small"
                            >
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="total-n-submit">
                    <p>Цена нормочаса без НДС:<span>48 руб</span></p>
                    <p><span>Итог:</span>{{ totalPrice ? totalPrice : 0 }}₽</p>
                </div>
                <button class="btn" @click="openStepPopup(2)">Продолжить</button>
            </div>
        </div>
        <div class="popup__step-two">
            <div class="popup__title" @click="openStepPopup(2)">
                <span>2</span>
                <p :class="{ active: currentStepPopup === 2 }">дата и время</p>
            </div>
            <div class="popup__step-wrap" :class="{ hidden: currentStepPopup !== 2 }">
                <el-date-picker
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    v-model="currentDate"
                    type="date"
                    placeholder="Укажите дату"
                    @change="setDate"
                    :clearable="false"
                >
                </el-date-picker>
                <el-time-select
                    v-model="currentTime"
                    :picker-options="{
            start: '08:30',
            step: '00:30',
            end: '18:30',
          }"
                    placeholder="Укажите время"
                    @change="setTime"
                    :clearable="false"
                >
                </el-time-select>
                <button class="btn" @click="openStepPopup(3)">Продолжить</button>
            </div>
        </div>
        <div class="popup__step-three">
            <div class="popup__title" @click="openStepPopup(3)">
                <span>3</span>
                <p :class="{ active: currentStepPopup === 3 }">подтверждение</p>
            </div>
            <div class="popup__step-wrap" :class="{ hidden: currentStepPopup !== 3 }">
                <form @submit.prevent="sendRequest" class="vue-form">
                    <label>
                        <input
                            type="text"
                            name="Name"
                            placeholder="Имя"
                            v-model="formData.name"
                        />
                        <p v-if="formErrors.name.show" class="error">
                            {{ formErrors.name.message }}
                        </p>
                    </label>
                    <label>
                        <input
                            type="tel"
                            name="tel"
                            placeholder="Телефон"
                            v-model="formData.tel"
                            v-mask="{ mask: '+375(99)999-99-99', greedy: true }"
                        />
                        <p v-if="formErrors.tel.show" class="error">
                            {{ formErrors.tel.message }}
                        </p>
                    </label>
                    <button class="btn">Заказать</button>
                </form>
            </div>
            <div class="thanks-popup" :class="{ open: thanksPopup }">
                <img :src="assets_url + '/images/Checkmark.png'" alt="Checkmark"/>
                <p>спасибо!<br/>ваша заявка принята.</p>
                <p>
                    В ближайшее время наш менеджер свяжется с Вами, чтобы обсудить детали.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
const regExp = {
    tel: RegExp("\\+[0-9]{3}\\(([0-9]{2})\\)([0-9]{3})-([0-9]{2})-([0-9]{2})"),
    name: RegExp("[a-zA-Z][a-zA-Z-_ ]{2,50}|[а-яА-Я][а-яА-Я-_ ]{2,50}"),
};
export default {
    props: {
        assets_url: {
            type: String,
        },
        isPopup: {
            type: Boolean,
        },
    },
    data: () => ({
        currentDate: null,
        currentTime: null,
        formData: {
            name: "",
            tel: "",
        },
        formErrors: {
            name: {
                show: false,
                message: "",
            },
            tel: {
                show: false,
                message: "",
            },
        },
        thanksPopup: false,
        open: false,
    }),
    mounted() {
        this.prefetchStorageData();
    },
    methods: {
        removeMark() {
            this.$store.dispatch("updateStateValue", {
                target: "manufactorer",
                value: '',
            });
        },
        removeModel() {
            this.$store.dispatch("updateStateValue", {
                target: "model",
                value: 'key',
            });
        },
        prefetchStorageData() {
            this.currentDate = this.selectedDate;
            this.currentTime = this.selectedTime;
        },
        goToStep(step) {
            this.$emit("goToStep", step);
        },

        openStepPopup(key) {
            this.$store.dispatch("updateStateValue", {
                target: "activeKeyPopup",
                value: key,
            });
        },
        deleteRow(row) {
            this.$store.dispatch("deleteSelectedWork", row);
        },
        workPriceToFixed(node) {
            return this.selectedWorks[node].workPrice.toFixed(1);
        },
        setDate(node) {
            this.$store.dispatch("updateStateValue", {
                target: "selected_date",
                value: node,
            });
            this.currentTime = null;
        },
        setTime(node) {
            this.$store.dispatch("updateStateValue", {
                target: "selected_time",
                value: node,
            });
        },
        sendRequest() {
            let valid = true;

            Object.keys(this.formData).forEach((item) => {
                if (!this.formData[item].length) {
                    valid = false;
                    this.formErrors[item].show = true;
                    this.formErrors[item].message = "Заполните поле";
                    setTimeout(() => {
                        this.formErrors[item].show = false;
                    }, 1000);
                    return;
                }
                if (!regExp[item].test(this.formData[item].replace(/\s/g, ""))) {
                    valid = false;
                    this.formErrors[item].show = true;
                    this.formErrors[item].message = "Заполните поле корректно";
                    setTimeout(() => {
                        this.formErrors[item].show = false;
                    }, 1000);
                    return;
                }
                this.formErrors[item].show = false;
            });
            if (valid) {
                let data = new FormData();

                data.append("action", "works");
                data.append("post_type", "works");
                data.append("post_title", this.selectedMark ? this.selectedMark.mark : 'Без марки автомобиля');
                data.append("mark", this.selectedMark ? this.selectedMark.mark : 'Без марки автомобиля');
                data.append("model", this.selectedModel ? this.selectedModel.model : 'Без модели автомобиля');
                data.append("engineDvs", this.selectedEngine ? this.selectedEngine.dvs : 'Без информации по двигателю');
                data.append("engineEngPower", this.selectedEngine ? this.selectedEngine.engPower : 'Без информации по двигателю');
                data.append("engineFuelInfo", this.selectedEngine ? this.selectedEngine.fuel_info : 'Без информации по двигателю');
                data.append("totalPrice", this.totalPrice);
                data.append("worksList", JSON.stringify(this.selectedWorks));
                if (this.selectedDate) {
                    data.append(
                        "selectedDate",
                        this.selectedDate.replace(
                            /([0-9]{4})-([0-9]{2})-([0-9]{2})(\S+)/,
                            "$3-$2-$1"
                        )
                    );
                }
                if (this.selectedTime) {
                    data.append("selectedTime", this.selectedTime);
                }
                data.append("name", this.formData["name"]);
                data.append("tel", this.formData["tel"]);

                fetch(`/wp-admin/admin-ajax.php`, {
                    method: "POST",
                    body: data,
                }).then((response) => {
                    console.log("success");
                    window.location = '/thanks'
                });

                setTimeout(() => {
                    this.$store.dispatch("restoreDefault");

                }, 2000);
            }
        },
    },
    computed: {
        /**
         * ID выбранной марки
         */
        selectedMark() {
            return this.$store.getters["getValue"]("manufactorer");
        },
        /**
         * Отслеживание модели авто
         */
        selectedModel() {
            return this.$store.getters["getValue"]("model");
        },
        /**
         * Отслеживание выбраных работ
         */
        selectedEngine() {
            return this.$store.getters["getValue"]("engine");
        },
        selectedWorks() {
            return this.$store.getters.getBothSelectedWorks;
        },

        /**
         * Отслеживание выбранной даты
         */
        selectedDate() {
            return this.$store.getters["getValue"]("selected_date");
        },
        /**
         * Отслеживание выбранного времени
         */
        selectedTime() {
            return this.$store.getters["getValue"]("selected_time");
        },
        totalPrice() {
            return this.$store.getters.cartPrice;
        },
        currentStepPopup: function () {
            return this.$store.getters.getActiveStepPopup;
        },
    },
    watch: {
        thanksPopup: function () {
        },
    },
};
</script>